// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"ae7df0fc","342":"c0bfadf1","453":"d855a71b"}[chunkId] + ".chunk.js";
};